import MasonryLayout from 'masonry-layout';
import Share from '../components/Share';

export default class StaticBlog {
  constructor(section) {
    this.el = section.el;
    this.grid = this.el.querySelector('[data-blog]');

    if (this.grid) {
      this.initializeMasonryGrid();
    }

    if (section.data.enable_sharing || section.type === 'static-search-results') {
      this.share = new Share({ el: this.el });
    }

    this.updateLayout = this.updateLayout.bind(this);
    this.el.addEventListener('rimg:load', this.updateLayout);
  }

  updateLayout() {
    if (this.masonry) {
      this.masonry.layout();
    }
  }

  initializeMasonryGrid() {
    this.masonry = new MasonryLayout(
      this.grid,
      {
        itemSelector: ('[data-article-item]'),
        columnWidth: '.article-grid-sizer',
        gutter: '.article-gutter-sizer',
        percentPosition: true,
      },
    );
  }

  onSectionUnload() {
    this.el.removeEventListener('rimg:load', this.updateLayout);
  }
}
